import Assessment from '..'
import assessmentSelector from '../selectors'
import { connect } from 'react-redux'
import {
  fetchSubscribedInstitutes,
  fetchSubscriptionRenewalInstitutes,
  fetchTotalCollegeCount,
  fetchActiveAssessmentCount,
  fetchAssessmentSentCount,
  fetchAssessmentCompletedCount,
  fetchInstitutesStates,
  fetchInstitutesCitiesByState,
  fetchInstitutesByCity,
  fetchAssessmentsByEntity,
  fetchAssessmentCorporateStates,
  fetchAssessmentCorporateCities,
  fetchAssessmentCorporateCompanies,
  fetchRecentActivityLogs,
  createAssessments,
  fetchActiveAssessments,
  fetchCompletedAssessments,
  setAssessmentFilters,
  setInstituteDomain,
  setInstituteDegree,
  setInstituteDepartment,
  setInstituteSpecialization,
  fetchStudentsByStatus,
  fetchAllStudentStatusCounts,
  setAssessmentCreationData,
  addBulkUploadData,
  clearAssessmentCreationData,
  exportStudentData,
  sendRemindersToStudents,
  resendInvitesToStudents,
  fetchAptitudeTopics,
  scheduleAssessments,
  fetchSpecificAssessmentStudentList
} from '../actions'

const mapStateToProps = state => ({
  subscribedInstitutes: assessmentSelector.selectSubscribedInstitutes(state),
  subscriptionRenewal:
    assessmentSelector.selectSubscriptionRenewalInstitutes(state),
  selectedInstitute: assessmentSelector.selectSelectedInstitute(state),
  loading: assessmentSelector.selectLoadingStatus(state),
  error: assessmentSelector.selectError(state),
  totalCollegeCount: assessmentSelector.selectTotalCollegeCount(state),
  activeAssessmentCount: assessmentSelector.selectActiveAssessmentCount(state),
  assessmentSentCount: assessmentSelector.selectAssessmentSentCount(state),
  assessmentCompletedCount:
    assessmentSelector.selectAssessmentCompletedCount(state),
  subscribedInstitutesMetrics:
    assessmentSelector.selectSubscribedInstitutesMetrics(state),
  subscriptionRenewalMetrics:
    assessmentSelector.selectSubscriptionRenewalMetrics(state),
  subscribedInstitutesPagination:
    assessmentSelector.selectSubscribedInstitutesPagination(state),
  subscriptionRenewalPagination:
    assessmentSelector.selectSubscriptionRenewalPagination(state),
  filters: assessmentSelector.selectFilters(state),

  // Active Assessment selectors
  activeAssessments: assessmentSelector.selectActiveAssessments(state),
  activeAssessmentsPagination:
    assessmentSelector.selectActiveAssessmentsPagination(state),
  activeAssessmentsMetrics:
    assessmentSelector.selectActiveAssessmentsMetrics(state),

  // Completed Assessment selectors
  completedAssessments: assessmentSelector.selectCompletedAssessments(state),
  completedAssessmentsPagination:
    assessmentSelector.selectCompletedAssessmentsPagination(state),
  completedAssessmentsMetrics:
    assessmentSelector.selectCompletedAssessmentsMetrics(state),
  roleBasedQuestionsState: state.SubscribedInstitutes.roleBasedQuestions, // <-- Add this line

  subscribedCount: assessmentSelector.selectSubscribedInstitutesTotal(state),
  renewalCount: assessmentSelector.selectSubscriptionRenewalTotal(state),
  subscribedInstitutesStates: assessmentSelector.selectInstitutesStates(state),
  subscribedInstitutesCities: assessmentSelector.selectInstitutesCities(state),
  subscribedInstitutesNames: assessmentSelector.selectInstitutesNames(state),
  subscribedAssessments: assessmentSelector.selectSubscribedAssessment(state),
  recentActivityLogs: assessmentSelector.selectRecentActivityLogs(state),
  stateCityPairs:
    state.SubscribedInstitutes?.subscribedInstitutesPagination
      ?.stateCityPairs || [],
  statesCityPairsRenewal:
    state.SubscribedInstitutes?.subscriptionRenewalPagination?.stateCityPairs ||
    [],
  aptitudeTopics: assessmentSelector.selectAptitudeTopics(state),
  aptitudeTopicsLoading: assessmentSelector.selectAptitudeTopicsLoading(state),
  aptitudeTopicsError: assessmentSelector.selectAptitudeTopicsError(state),
  formattedAptitudeTopics: assessmentSelector.selectFormattedAptitudeTopics(state),
  stateCityPairsActive:
    state.SubscribedInstitutes?.activeAssessmentsPagination?.stateCityPairs ||
    [],

  stateCityPairsCompleted:
    state.SubscribedInstitutes?.completedAssessmentsPagination
      ?.stateCityPairs || [],
  assessmentFilters: assessmentSelector.selectAssessmentFilters(state),
  instituteDomain: assessmentSelector.selectInstituteDomain(state),
  instituteDegree: assessmentSelector.selectInstituteDegree(state),
  instituteDepartment: assessmentSelector.selectInstituteDepartment(state),
  instituteSpecialization:
    assessmentSelector.selectInstituteSpecialization(state),

  studentDataSent: assessmentSelector.selectStudentDataSent(state),
  studentDataPending: assessmentSelector.selectStudentDataPending(state),
  studentDataInProgress: assessmentSelector.selectStudentDataInProgress(state),
  studentDataDroppedOff: assessmentSelector.selectStudentDataDroppedOff(state),
  studentDataCompleted: assessmentSelector.selectStudentDataCompleted(state),
  studentDataLoading: assessmentSelector.selectStudentDataLoading(state),
  assessmentCreationData:
    assessmentSelector.selectAssessmentCreationData(state),
  corporateStates: state.SubscribedInstitutes.assessmentCorporateStates,
  corporateCities: state.SubscribedInstitutes.assessmentCorporateCities,
  corporateCompanies: state.SubscribedInstitutes.assessmentCorporateCompanies,
  assessmentInfo: state.SubscribedInstitutes.assessmentInfo,
  deliveryFunnel: state.SubscribedInstitutes.deliveryFunnel,
})

const mapDispatchToProps = {
  fetchSubscribedInstitutes,
  fetchSubscriptionRenewalInstitutes,
  fetchTotalCollegeCount,
  fetchActiveAssessmentCount,
  fetchAssessmentSentCount,
  fetchAssessmentCompletedCount,
  fetchInstitutesStates,
  fetchInstitutesCitiesByState,
  fetchInstitutesByCity,
  fetchAssessmentsByEntity,
  fetchCorporateStates: fetchAssessmentCorporateStates,
  fetchCorporateCities: fetchAssessmentCorporateCities,
  fetchCorporateCompanies: fetchAssessmentCorporateCompanies,
  fetchRecentActivityLogs,
  createAssessments,
  fetchActiveAssessments,
  fetchCompletedAssessments,
  setAssessmentFilters,
  setInstituteDomain,
  setInstituteDegree,
  setInstituteDepartment,
  setInstituteSpecialization,
  fetchStudentsByStatus,
  fetchAllStudentStatusCounts,
  setAssessmentCreationData,
  addBulkUploadData,
  clearAssessmentCreationData,
  exportStudentData,
  sendRemindersToStudents,
  resendInvitesToStudents,
  fetchAptitudeTopics,
  scheduleAssessments,
  fetchSpecificAssessmentStudentList
}

const ConnectedAssessment = connect(
  mapStateToProps,
  mapDispatchToProps
)(Assessment)

export default ConnectedAssessment
